module.exports = __webpack_public_path__ + "static/img/module_style_05.58e0bea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ossmanage/module_style_05.png
// module id = W8yS
// module chunks = 0